module.exports = __webpack_public_path__ + "media/2.1_comparative_example_glass_cf1.490298b8.wav";